import api, { apiRequest } from './api';
import type { Game, Difficulty, Progress, UserStats } from '@shared/types';

export const gameService = {
  /**
   * Obtener todos los juegos
   */
  async getAllGames(siteType?: 'neureka' | 'kids'): Promise<Game[]> {
    return apiRequest<Game[]>(
      api.get('/games', { params: { siteType } })
    );
  },

  /**
   * Obtener juego por código
   */
  async getGameByCode(gameCode: string): Promise<Game> {
    return apiRequest<Game>(
      api.get(`/games/${gameCode}`)
    );
  },

  /**
   * Obtener dificultades de un juego
   */
  async getGameDifficulties(gameCode: string): Promise<Difficulty[]> {
    return apiRequest<Difficulty[]>(
      api.get(`/games/${gameCode}/difficulties`)
    );
  },

  /**
   * Obtener progreso del usuario
   */
  async getUserProgress(params?: {
    gameId?: number;
    tipoNivel?: string;
  }): Promise<Progress[]> {
    return apiRequest<Progress[]>(
      api.get('/progress', { params })
    );
  },

  /**
   * Guardar progreso
   */
  async saveProgress(data: {
    juego_id?: number;
    tipo_nivel: string;
    nivel_id: number;
    tablero_id?: number;
    tiempo: number;
    movimientos: number;
    tiempo_reaccion?: number;
    completado?: boolean;
  }): Promise<{ id: number }> {
    return apiRequest<{ id: number }>(
      api.post('/progress', data)
    );
  },

  /**
   * Obtener estadísticas del usuario
   */
  async getUserStats(): Promise<UserStats> {
    return apiRequest<UserStats>(
      api.get('/stats')
    );
  },
};
